import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IFormController, IPromise} from "angular";
import {Kontekst} from "felles/tjenester/Kontekst";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {Debugger} from 'debug'
import {RedigerÅrshjulinnslagModell} from "../../../gruppe/komponenter/årshjulskjema/årshjulinnslagskjema";
import {ÅrshjulRessurs} from "felles/tjenester/ressurser/ÅrshjulRessurs";
import {MdDialogController} from "../../../../tjenester/Dialog";

const debug: Debugger = require('debug')('RedigerÅrshjulinnslagDialog');


export class RedigerÅrshjulinnslagDialog implements MdDialogController {

    static visNyttÅrshjulinnslagDialog(gruppeId: string, uke: number, $mdDialog: angular.material.IDialogService): IPromise<ÅrshjulinnslagDialogRespons> {
        return $mdDialog.show(this.dialogKonfigurasjon({gruppeId: gruppeId, uke: uke, modus: 'nytt'}));
    }

    static visÅrshjulinnslagDialog(innslag: l.ÅrshjulInnslagModell, $mdDialog: angular.material.IDialogService): IPromise<ÅrshjulinnslagDialogRespons> {
        return $mdDialog.show(this.dialogKonfigurasjon({innslag: innslag, gruppeId: innslag.gruppeId, uke: innslag.startuke, modus: 'vis'}));
    }

    static visÅrshjulinnslagUtenforÅrsplankontekstDialog(innslag: l.ÅrshjulInnslagModell, $mdDialog: angular.material.IDialogService): IPromise<ÅrshjulinnslagDialogRespons> {
        return $mdDialog.show(this.dialogKonfigurasjon({innslag: innslag, gruppeId: innslag.gruppeId, uke: innslag.startuke, modus: 'visUtenforÅrsplankontekst'}));
    }

    private static dialogKonfigurasjon(locals: Object): angular.material.IDialogOptions {
        return {
            template: require('./redigerÅrshjulinnslagDialog.html'),
            controller: RedigerÅrshjulinnslagDialog.forInjisering(),
            controllerAs: '$ctrl',
            bindToController: true,
            locals: locals
        };
    }

    static forInjisering() {
        return [
            Kontekst.regNavn,
            regNavn.md.$mdDialog,
            ÅrshjulRessurs.regNavn,
            RedigerÅrshjulinnslagDialog
        ]
    }

    constructor(private kontekst: Kontekst,
                private $mdDialog: angular.material.IDialogService,
                private årshjulRessurs: ÅrshjulRessurs) {
    }

    modus: 'vis'|'visUtenforÅrsplankontekst'|'rediger'|'nytt'; //settes via bindings
    gruppeId: string; //settes via bindings
    uke: number; //settes via bindings
    innslag: l.ÅrshjulInnslagModell; //settes via bindings (kun satt ved vis/rediger)

    data: RedigerÅrshjulinnslagModell;

    gruppe() {
        return this.kontekst.finnAutentiserteGruppe(this.gruppeId);
    }

    gaaTilAarshjul(){
        this.$mdDialog.hide();
    }

    gaaTilNyttmodus(){
        this.modus = 'nytt';
        this.data = RedigerÅrshjulinnslagModell.tomRedigerÅrshjulinnslagModell(this.uke, this.gruppeId);
    }

    gaaTilRedigermodus(){
        this.modus = 'rediger';
        this.data = new RedigerÅrshjulinnslagModell(this.innslag);
    }

    slett() {
        this.årshjulRessurs.slett(this.innslag.id).$promise
            .then(() => {
                 this.$mdDialog.hide({type: 'slettet', innslag: this.innslag});
            })
    }

    lagre(skjema: IFormController) {
        if (!skjema.$valid) return;

        if (this.modus == 'nytt') this.opprettNy();
        else this.lagreEksisterende();
    }

    avbryt() {
        this.lukkDialog();
    }

    $onInit() {
        if (this.modus == 'nytt') this.gaaTilNyttmodus();
        if (this.modus == 'rediger') this.gaaTilRedigermodus();
    }

    //hjelpemetoder

    private opprettNy() {
        this.årshjulRessurs.opprettInnslag(this.gruppeId, this.data.spesifikasjon).$promise
            .then(innslag => this.$mdDialog.hide({type: 'nytt', innslag: innslag}))
    }

    private lagreEksisterende() {
        this.årshjulRessurs.oppdater(this.data.spesifikasjon).$promise
            .then(innslag => this.$mdDialog.hide({type: 'oppdatert', innslag: innslag}))
    }

    private lukkDialog() {
        this.$mdDialog.cancel();
    }

}

export interface ÅrshjulinnslagDialogRespons{
    type: 'oppdatert'|'nytt'|'slettet'
    innslag: l.ÅrshjulInnslagModell;
}
